<template>
    <div id="PhoneLocation">
      <p class="mb-5">
        {{$t('To go to level four, at least one week must have passed since level four, and the total amount of Rial deposits and withdrawals must have reached 100 million Tomans.')}}
        <br>
        {{$t('After registering the phone and pressing the confirmation button, a voice call is made to the inserted phone.')}}
        <br>
        {{$t('Enter the address completely and together with the province, city, street, alley, license plate and unit, otherwise your address information will not be confirmed.')}}
      </p>

      <vs-alert color="warning" :title="$t('pending')" active="true" v-if="status=='pending'">
        {{$t('Your information is under review and please wait!')}}
      </vs-alert>
      <vs-alert color="danger" :title="$t('reject')" active="true" v-else-if="status=='reject'">
        {{dataUser.address['reason_'+islocale]}}
      </vs-alert>
      <vs-alert color="success" :title="$t('confirm')" active="true" v-else-if="status=='confirm'" icon-pack="feather" icon="icon-check">
        {{$t('The information in this section has been successfully verified.')}}
      </vs-alert>

      <form data-vv-scope="PhoneLocation" autocomplete="off">
        <div class="vx-col md:w-2/5 w-full mt-5 mx-auto">
          <div class="vx-row">
            <div class="vx-col w-full mt-5 mx-auto">
              <vs-input :label="$t('Phone')" v-model="phone" :disabled="sendSms" name="phone" maxlength="12" class="w-full" :class="$vs.rtl ? 'rtl' : 'ltr'"
                        v-validate="'required|min:12|max:12'" v-mask="PhoneMask" :readonly="status=='pending'|| status=='confirm' ? true : false"
                        :success="status=='confirm' ? true : false" :warning="status=='pending' ? true : false"
                        val-icon-success="icon-check" val-icon-warning="icon-clock" val-icon-pack="feather"/>
              <span class="text-danger text-sm" v-show="errors.firstByRule('PhoneLocation.phone','required') && this.LocationSubmit">{{ errors.firstByRule('PhoneLocation.phone','required') }}</span>
              <span class="text-danger text-sm" v-show="errors.firstByRule('PhoneLocation.phone','min') && this.LocationSubmit">شماره تلفن را بصورت صحیح درج کنید</span>
            </div>
          </div>

          <transition name="slide">
            <div class="vx-row" v-if="sendSms">
              <div class="vx-col w-full mt-5">
                <vs-input :label="$t('Four-digit code')" v-model="code" name="code" maxlength="4" class="w-full"
                          :class="$vs.rtl ? 'rtl' : 'ltr'" v-validate="'required|numeric|min:4|max:4'" ref="codeInput"/>
                <span class="text-danger text-sm" v-show="errors.has('PhoneLocation.code') && this.LocationSubmit">{{ errors.first('PhoneLocation.code') }}</span>
              </div>
            </div>
          </transition>

          <div class="vx-row">
            <div class="vx-col w-full mt-5 mx-auto">
              <label>{{$t('Address')}} <small>{{$t('(with province, city, street, alley, license plate and unit)')}}</small></label>
              <vs-textarea v-model="address" name="address" class="w-full" v-validate="'required|min:5'"
                           :readonly="status=='pending'|| status=='confirm' ? true : false"
                           :success="status=='confirm' ? true : false" :warning="status=='pending' ? true : false"
                           val-icon-success="icon-check" val-icon-warning="icon-clock" val-icon-pack="feather"/>
              <span class="text-danger text-sm" v-show="errors.has('PhoneLocation.address') && this.LocationSubmit">{{ errors.first('PhoneLocation.address') }}</span>
            </div>

            <div class="vx-col w-full mt-8 mx-auto">
              <p class="mb-1">{{$t('Provide a picture of the residence document (bills, lease, etc.):')}}</p>
              <div :class="$vs.rtl ? 'rtl' : 'ltr'" dir="ltr">
                <file-pond
                  :class="status=='pending'?'warning' : status=='confirm'?'success' : ''"
                  name="test"
                  ref="pond"
                  :disabled="status=='pending'|| status=='confirm'  ? true : false"
                  :captureMethod="null"
                  :label-idle="$t('Click to upload the file or drag and drop the file')"
                  accepted-file-types="image/jpeg, image/png"
                  v-bind:server="myServer"
                  :files="status=='pending'||status=='confirm' ? myFiles : null"
                  :processfile="null"
                />
              </div>
            </div>

            <transition name="slide">
              <div class="w-full flex px-3" v-if="uploadPercentage > 0">
                <p class="mr-3 text-center">{{uploadPercentage}}%</p>
                <vs-progress class="mt-1" :height="12" :percent="uploadPercentage" color="success"></vs-progress>
              </div>
            </transition>

            <div class="vx-col w-full"></div>
            <div class="vx-col w-full mt-5 mx-auto">
              <vs-button class="ml-auto mt-2 w-full" id="button-submit-location" :disabled="btnDisable ||status=='pending'||status=='confirm' ? true : false"
                         @click.prevent="LocationFormSubmit">{{!sendSms ? $t('Send verification code') : $t('Submit Information')}}</vs-button>
            </div>
          </div>
        </div>
      </form>
    </div>
</template>

<i18n locale="fa">
{

  "Please insert the file!":"لطفا فایل را درج کنید!"
  ,"Four-digit code":"کد چهار رقمی"
  ,"Your information is under review and please wait!":"اطلاعات شما در دست بررسی قرار دارد و لطفا منتظر بمانید!"
  ,"The information in this section has been successfully verified.":"اطلاعات این بخش با موفقیت تایید شده است."
  ,"(with province, city, street, alley, license plate and unit)":"(همراه با استان، شهر، خیابان، کوچه، پلاک و واحد)"
  ,"Provide a picture of the residence document (bills, lease, etc.):":"ارائه تصویر سند محل سکونت (قبوض، اجاره نامه و ...):"

  ,"After registering the phone and pressing the confirmation button, a voice call is made to the inserted phone.":
  "بعد از ثبت تلفن و زدن دکمه تایید، تماس صوتی با تلفن درج شده برقرار میشود."

  ,"Enter the address completely and together with the province, city, street, alley, license plate and unit, otherwise your address information will not be confirmed.":
  "آدرس را بصورت کامل و همراه با استان، شهر، خیابان، کوچه، پلاک و واحد درج کنید و در غیر این صورت اطلاعات آدرس شما تایید نمیشود."

  ,"To go to level four, at least one week must have passed since level four, and the total amount of Rial deposits and withdrawals must have reached 100 million Tomans.":
  "برای رفتن به سطح چهار باید حداقل یک هفته از سطح چهار گذشته باشد و جمع واریز و برداشت های ریالی به ۱۰۰ میلیون تومان رسیده باشد."
}
</i18n>

<script>

// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'
// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import axios from "../../../http/axios";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
)
export default {
  props: {
    dataUser: {
      required: true,
    }
  },
  data () {
    return {
      PhoneMask: {
        mask: '###-########',
        tokens: {
          '#': {
            pattern: /[0-9٠١٢٣٤٥٦٧٨٩]/,
            transform (v) {
              return v.toLocaleUpperCase()
            }
          }
        }
      },
      phone: '',
      code: '',
      sendSms:false,
      address: '',
      myFiles: [
        {
          source:
            "authentication/location/image.jpg",
          options: {
            type: "local"
          }
        }
      ],
      LocationSubmit: false,
      status: null,
      uploadPercentage:0,
      btnDisable: false,
      myServer: {
        process: null,
        load: (source, load) => {
          axios.get(source, {responseType: 'blob' })
            .then((response) => {
              const new_blob = new Blob( [ response.data ], { type: 'image/jpg' } );
              load(new_blob)
          })
        }
      },
    }
  },
  watch:{
    phone (value) {
      return this.phone = this.parseNumberArabic(value)
    }
  },
  methods: {
    LocationFormSubmit () {
      this.$validator.validateAll('PhoneLocation').then(result => {
        if (result) {

          if(!this.$refs.pond.getFiles()[0] && this.code.length == 4){
            this.$swal(this.$t('Warning'), this.$t('Please insert the file!'),'warning')
            return;
          }

          this.$vs.loading({
            background: this.backgroundLoading,
            color: this.colorLoading,
            container: '#button-submit-location',
            scale: 0.65
          })
          this.btnDisable = true;
          const bodyFormData = new FormData();
          bodyFormData.append('phone',this.phone.replace(/\-/g, ''))
          bodyFormData.append('address',this.address)
          bodyFormData.append('code',this.code)
          if(this.code.length == 4)
            bodyFormData.append('file', this.$refs.pond.getFiles()[0].file);

          const self = this
          axios.post('/authentication/location', bodyFormData,{
            onUploadProgress: function( progressEvent ) {
              if(this.code.length == 4)
                this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
            }.bind(this)
          })
            .then(function (response) {
              if (response.data.status == true) {
                if(response.data.send == true){
                  self.sendSms = true;
                  self.$vs.notify({title: self.$t('Success'), text: response.data.msg, iconPack: 'feather', icon: 'icon-check-circle', color: 'success'})
                  setTimeout(()=>{
                    self.$refs.codeInput.$el.querySelector('input').focus()
                  },500)
                }
                else if(response.data.done == true) {
                  self.$swal({
                    icon: 'success',
                    title: self.$t('Success'),
                    text: response.data.msg
                  }).then(() => {
                    self.$emit('getData')
                    self.status = 'pending'
                  })
                  self.sendSms = false
                }
              } else {
                self.$vs.notify({title: self.$t('Error'), text: response.data.msg, iconPack: 'feather', icon: 'icon-alert-circle', color: 'danger',time:6000})
              }
              self.btnDisable = false
              self.uploadPercentage = 0
              self.$vs.loading.close('#button-submit-location > .con-vs-loading')
            })
            .catch(function (error) {
              console.log(error)
              self.uploadPercentage = 0
              self.btnDisable = false
              self.$vs.loading.close('#button-submit-location > .con-vs-loading')
            })
        } else {
          this.LocationSubmit = true
        }
      })
    },
    parseNumberArabic (value) {
      return (value.replace(/[٠١٢٣٤٥٦٧٨٩]/g, function (d) {
        return d.charCodeAt(0) - 1632
      }).replace(/[۰۱۲۳۴۵۶۷۸۹]/g, function (d) { return d.charCodeAt(0) - 1776 })
      )
    }
  },
  created() {
    if(this.dataUser.address && this.dataUser.address.status){
      this.status = this.dataUser.address.status;
      this.phone = this.dataUser.phone;
      this.address = this.dataUser.address.address;
    }
  },
  components: {
    FilePond
  }
}
</script>

<style lang="scss">
  #PhoneLocation {
    .vs-con-textarea {
      margin-bottom: 0;
    }

    .rtl .filepond--wrapper div{
      direction: rtl;
      text-align: right;
    }
    .rtl .filepond--wrapper .filepond--file-info{
      margin: 0em;
    }

    .rtl .filepond--file .filepond--file-status{
      margin-right: auto;
      margin-left: 2.25em !important;
    }

    .filepond--file-info,.filepond--file-status{
      font-size: 18px !important;
    }
    .filepond--credits{
      display: none;
    }

    .filepond--file-action-button,.filepond--drop-label, .filepond--drop-label label{
      cursor: pointer;
    }

    /* the text color of the drop label*/
    .filepond--drop-label {
      color: #555;
      font-family: iranyekan,"Montserrat", Helvetica, Arial, sans-serif;
    }

    /* underline color for "Browse" button */
    .filepond--label-action {
      text-decoration-color: #aaa;
    }

    /* the background color of the filepond drop area */
    .filepond--panel-root {
      background-color: #eee;
    }

    /* the border radius of the drop area */
    .filepond--panel-root {
      border-radius: 0.5em;
    }

    /* the border radius of the file item */
    .filepond--item-panel {
      border-radius: 0.5em;
    }

    /* the background color of the file and file panel (used when dropping an image) */
    .filepond--item-panel {
      background-color: #555;
    }

    /* the background color of the drop circle */
    .filepond--drip-blob {
      background-color: #999;
    }

    /* the background color of the black action buttons */
    .filepond--file-action-button {
      background-color: rgba(0, 0, 0, 0.5);
    }

    /* the icon color of the black action buttons */
    .filepond--file-action-button {
      color: white;
    }

    /* the color of the focus ring */
    .filepond--file-action-button:hover,
    .filepond--file-action-button:focus {
      box-shadow: 0 0 0 0.125em rgba(255, 255, 255, 0.9);
    }

    /* the text color of the file status and info labels */
    .filepond--file {
      color: white;
    }

    /* error state color */
    [data-filepond-item-state*='error'] .filepond--item-panel,
    [data-filepond-item-state*='invalid'] .filepond--item-panel {
      //background-color: red;
    }

    [data-filepond-item-state='processing-complete'] .filepond--item-panel {
      background-color: green;
    }

    /* bordered drop area */
    .filepond--panel-root {
      background-color: transparent;
      border: 2px solid #2c3340;
    }

    .filepond--file-status-sub,.filepond--file-info-sub{
      opacity: 0.8 !important;
    }

    .filepond--file-status-sub,.filepond--file-info-sub{
      opacity: 0.8 !important;
    }
    .success .filepond--panel-root{
      border-color: rgba(var(--vs-success), 1) !important;
    }
    .warning .filepond--panel-root{
      border-color: rgba(var(--vs-warning), 1) !important;
    }
  }
</style>
